export const model = {
  global: {
    tabClassName: "mytab",
    tabSetEnableMaximize: false,
    tabSetClassNameTabStrip: "mytabstrip",
  },
  borders: [],
  layout: {
    type: "row",
    id: "#c4f61be1-a9fd-46a5-9104-cdf174667540",
    children: [
      {
        type: "row",
        id: "#82c018a6-7454-4f2d-901f-b1153dcb61a9",
        children: [
          {
            type: "tabset",
            id: "#a6ceb3db-a5c0-40a6-9058-acdzaece22b97x",
            weight: 6.224786656250471,
            tabStripHeight: 6,
            children: [
              {
                type: "tab",
                id: "#d7203016-ec93-4600-852a-z62ad41b5881ccx",
                name: "",
                component: "Header",
                enableClose: false,
                enableFloat: false,
              },
            ],
          },
          {
            type: "tabset",
            id: "#a6ceb3db-a5c0-40a6-9058-acdaece22b97x",
            weight: 7.374290679117719,
            tabStripHeight: 6,
            children: [
              {
                type: "tab",
                id: "#d7203016-ec93-4600-852a-62ad41b5881ccx",
                name: "",
                component: "Controls",
                enableClose: false,
                enableFloat: false,
              },
            ],
          },
          {
            type: "tabset",
            id: "#a6ceb3db-a5c0-40a6-9058-acdaece22b97er",
            weight: 106.84527828410562,
            tabStripHeight: 6,
            children: [
              {
                type: "tab",
                id: "#d7203016-ec93-4600-852a-62ad41b5881ccggg",
                name: "",
                component: "StoredValue",
                enableClose: false,
                enableFloat: false,
              },
            ],
          },
        ],
      },
    ],
  },
};
